import { render, staticRenderFns } from "./wait.vue?vue&type=template&id=37b1e3fe&scoped=true&"
import script from "./wait.vue?vue&type=script&lang=js&"
export * from "./wait.vue?vue&type=script&lang=js&"
import style0 from "./wait.vue?vue&type=style&index=0&lang=css&"
import style1 from "./wait.vue?vue&type=style&index=1&id=37b1e3fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b1e3fe",
  null
  
)

export default component.exports